module.exports = __webpack_public_path__ + "static/img/bg-ar.61f16073.png";